import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login';
import { 
         PagenotfoundComponent,
         CifrascontrolComponent, 
         BitacorramovComponent, 
         BinmanagerComponent,
         SearchEjecutorComponent,
         SearchSupervisorComponent,
         SearchPrevencionComponent, 
         BinesAbcComponent       
       } from './pages';

import { AuthGuard } from './_guards/auth.guard';
import { Role, Pages } from './_models/oauth.models'; 
import { DetalleBinComponent } from './pages/detalle-bin-sup/detalle-bin-sup.component';
import { DetalleBinPrevComponent } from './pages/detalle-bin-prev/detalle-bin-prev.component';
import { AlertasComponent } from './pages/alertas/alertas.component';
import { DetalleAlertaComponent } from './pages/alertas/detalle-alerta/detalle-alerta.component';
import { AdministracionComponent } from './pages/administracion/administracion.component';
import { LoginForgeComponent } from './loginForge/login-forge.component';
import { ConfiguracionComponent } from './pages/configuracion/configuracion.component';
import { MovimientosAutomaticosComponent } from './pages/movimientos-automaticos/movimientos-automaticos.component';

const appRoutes: Routes = [
  { 
    path: '', component: LoginComponent
  },
  {
    path: Pages.path_pagenotfound, component: PagenotfoundComponent,    
  },  
  {
    path: Pages.path_cifrascontrol, 
    component: CifrascontrolComponent, 
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor, Role.Supervisor, Role.Auditoria] }
  },
  {
    path: Pages.path_bitacotamovim, 
    component: BitacorramovComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor,Role.Supervisor, Role.Auditoria] }
  },
  {
    path: Pages.path_binmanager, 
    component: BinmanagerComponent ,
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor] }
  },
  {
    path: Pages.path_binesAbc, 
    component: BinesAbcComponent ,
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor] }
  },
  {
    path: Pages.path_binesAbcAlta, 
    component: BinesAbcComponent ,
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor] }
  },
  {
    path: Pages.path_binesAbc_edit, 
    component: BinesAbcComponent ,
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor, Role.Supervisor, Role.Prevencion] }
  },
  {
    path: Pages.path_busquedasejec, 
    component: SearchEjecutorComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor] }
  },
  {
    path: Pages.path_busquedassupe, 
    component: SearchSupervisorComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Supervisor] }
  },
  {
    path: Pages.path_checksupe, 
    component: SearchSupervisorComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Supervisor] }
  },
  {
    path: Pages.path_busquedasprev, 
    component: SearchPrevencionComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Prevencion] }
  },
  {
    path: Pages.path_detalle_bin, 
    component: DetalleBinComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Supervisor,Role.Ejecutor] }
  },
  {
    path: Pages.path_detalle_bin_prev, 
    component: DetalleBinPrevComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor, Role.Prevencion] }
  },
  {
    path: Pages.path_detalle_alerta, 
    component: DetalleAlertaComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor, Role.Prevencion, Role.Auditoria, Role.Supervisor] }
  },
  {
    path: Pages.path_alertas, 
    component: AlertasComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor, Role.Prevencion, Role.Auditoria, Role.Supervisor] }
  },
  {
    path: Pages.path_administracion, 
    component: AdministracionComponent, 
    canActivate: [AuthGuard],
    data: { roles: [Role.Administrador, Role.Supervisor] }
  },
  {
    path: Pages.path_configuracion, 
    component: ConfiguracionComponent, 
    canActivate: [AuthGuard],
    data: { roles: [Role.Administrador, Role.Supervisor] }
  },
  {
    path: Pages.path_movimientos_automaticos, 
    component: MovimientosAutomaticosComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Supervisor,Role.Ejecutor, Role.Auditoria] }
  },
  {
    path: 'instituciones',
    loadChildren: './pages/instituciones/instituciones.module#InstitucionesModule',
    canActivate: [AuthGuard],
    data: { roles: [Role.Ejecutor, Role.Supervisor, Role.Administrador] }
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes);